// src/services/projectService.ts
import ApiService from './api';
import { Project, Task, TimeEntry } from '../types';

class ProjectService {
  async getProject(id: number): Promise<Project> {
    const token = localStorage.getItem('token');
    return ApiService.get<Project>(`/api/projects/${id}`, token || undefined);
  }

  async getProjects(): Promise<Project[]> {
    const token = localStorage.getItem('token');
    const response = await ApiService.get<{projects: Project[]}>('/api/projects', token || undefined);
    return response.projects || [];
  }

  async createProject(project: Omit<Project, 'id' | 'created_at'>): Promise<Project> {
    const token = localStorage.getItem('token');
    return ApiService.post<Project>('/api/projects', project, token || undefined);
  }

  async updateProject(id: number, project: Partial<Project>): Promise<Project> {
    const token = localStorage.getItem('token');
    return ApiService.put<Project>(`/api/projects/${id}`, project, token || undefined);
  }

  async deleteProject(id: number): Promise<void> {
    const token = localStorage.getItem('token');
    return ApiService.delete<void>(`/api/projects/${id}`, token || undefined);
  }

  // Project Tasks
  async getProjectTasks(projectId: number): Promise<Task[]> {
    const token = localStorage.getItem('token');
    return ApiService.get<Task[]>(`/api/projects/${projectId}/tasks`, token || undefined);
  }

  async createTask(projectId: number, task: Omit<Task, 'id' | 'project_id' | 'created_at'>): Promise<Task> {
    const token = localStorage.getItem('token');
    return ApiService.post<Task>(`/api/projects/${projectId}/tasks`, task, token || undefined);
  }

  async updateTask(taskId: number, task: Partial<Task>): Promise<Task> {
    const token = localStorage.getItem('token');
    return ApiService.put<Task>(`/api/tasks/${taskId}`, task, token || undefined);
  }

  async deleteTask(taskId: number): Promise<void> {
    const token = localStorage.getItem('token');
    return ApiService.delete<void>(`/api/tasks/${taskId}`, token || undefined);
  }

  // Project Time Entries
  async getProjectTimeEntries(projectId: number): Promise<TimeEntry[]> {
    const token = localStorage.getItem('token');
    return ApiService.get<TimeEntry[]>(`/api/projects/${projectId}/time-entries`, token || undefined);
  }

  async createTimeEntry(timeEntry: Omit<TimeEntry, 'id' | 'created_at'>): Promise<TimeEntry> {
    const token = localStorage.getItem('token');
    return ApiService.post<TimeEntry>('/api/time-entries', timeEntry, token || undefined);
  }

  async updateTimeEntry(id: number, timeEntry: Partial<TimeEntry>): Promise<TimeEntry> {
    const token = localStorage.getItem('token');
    return ApiService.put<TimeEntry>(`/api/time-entries/${id}`, timeEntry, token || undefined);
  }

  async deleteTimeEntry(id: number): Promise<void> {
    const token = localStorage.getItem('token');
    return ApiService.delete<void>(`/api/time-entries/${id}`, token || undefined);
  }
}

const projectService = new ProjectService();
export default projectService;